import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

type Asset = 'BTC' | 'ETH';
type Range = '7d' | '30d' | '90d';

interface EtfFlowAgg {
  asset: string;
  date: string;
  total_net_flow_usd: number;
  total_in_usd: number;
  total_out_usd: number;
  tickers_count: number;
}

interface EtfFlowsResponse {
  asset: Asset;
  range: Range;
  group: string;
  data: EtfFlowAgg[];
}

export const useEtfFlows = (asset: Asset, range: Range = '7d') => {
  return useQuery({
    queryKey: ['etf-flows', asset, range],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('etf-flows-api', {
        body: { asset, range, group: 'agg' }
      });

      if (error) throw error;
      
      return data as EtfFlowsResponse;
    },
    staleTime: 5 * 60 * 1000, // 5 min
    refetchInterval: 10 * 60 * 1000, // 10 min
  });
};
